<aside
  class="flex-shrink-0 sticky top-0 z-[999] border-r transition-all duration-300 flex flex-col h-full relative bg-white/80 border-[#EAEAEA] dark:border-line backdrop-blur-xl dark:bg-surface-1"
  [ngClass]="{
    'w-20': isCollapsed(),
    'w-64': !isCollapsed()
  }"
>
  <div class="flex flex-col h-full">
    <!-- Header Section with Logo -->
    <div class="flex-shrink-0 h-16">
      <div
        class="flex items-center justify-between backdrop-blur-xl border-b h-full w-full px-4 border-[#EAEAEA] dark:border-line"
      >
        @if (isCollapsed()) {
        <div class="flex justify-center w-full">
          <app-prism-logo className="w-12 h-12 transition-all duration-300" />
          <!-- <img src="/prism-new-logo.svg" alt=""> -->
        </div>
        } @else {
        <div class="flex items-center gap-3">
          <app-prism-logo className="w-12 h-12 transition-all duration-300" />
          <!-- <img src="/prism-new-logo.svg" alt=""> -->
          <div>
            <div class="text-slate-900 dark:text-white">Prism Project</div>
            <div class="text-xs text-slate-600 dark:text-slate-400">AI CRM</div>
          </div>
        </div>
        }
      </div>
    </div>

    <div
      [class.max-h-0]="isCollapsed()"
      [class.opacity-0]="isCollapsed()"
      [class.pointer-events-none]="isCollapsed()"
      class="px-4 pt-4 transition-all duration-300"
    >
      <app-dropdown
        variant="default"
        [options]="productsList()"
        selectionMode="single"
        placeholder="Select a product"
        [defaultValue]="defaultProduct()"
        (selectionChange)="onProductChange($event)"
      >
      </app-dropdown>
    </div>

    <!-- Scrollable Menu Section -->
    <div
      class="flex-1 overflow-y-auto overflow-x-hidden px-4 py-6 scrollbar-theme scrollbar-thumb-slate-300 scrollbar-track-slate-100 dark:scrollbar-thumb-purple-400/40 dark:scrollbar-track-transparent"
    >
      <nav class="space-y-1">
        @for (item of menuItems; track item.id || item.label) {
        <!-- <div class="space-y-2">
          <button
            [routerLink]="['/app/page-routes']"
            class="w-full flex items-center gap-3 p-2 rounded-lg transition-all duration-200 text-slate-600 hover:bg-purple-50 hover:text-purple-600 dark:text-slate-300 dark:hover:bg-white/5 dark:hover:text-white"
          >
            <app-icon name="ChevronLeft" [size]="20" class="flex-shrink-0" />

            @if (!isCollapsed()) {
            <span class="font-medium truncate">Menu</span> }
          </button>
        </div> -->

        <div class="space-y-1 mb-2">
          <!-- Main Menu Item -->
          <div class="relative flex items-center justify-center">
            @if (hasVisibleChildren(item)) {
            <!-- Menu item with children -->
            <button
              #menuButton
              (click)="toggleExpanded(item)"
              (mouseenter)="onItemHover(item, menuButton)"
              (mouseleave)="onItemLeave()"
              class="w-full cursor-pointer flex items-center justify-between p-3 rounded-xl transition-all duration-200 text-slate-700 hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-slate-800/80"
              [ngClass]="{
                active: isParentOrChildActive(item),
                'bg-slate-100': hasVisibleChildren(item) && item.expanded,
                'dark:bg-slate-800/70': hasVisibleChildren(item) && item.expanded,
                'shadow-sm': hasVisibleChildren(item) && item.expanded,
              }"
            >
              <div class="flex items-center gap-3 min-w-0 flex-1">
                <app-icon-v2
                  [name]="item.icon"
                  [size]="20"
                  class="flex-shrink-0 text-slate-600 dark:text-slate-300"
                />
                @if (!isCollapsed()) {
                <span class="font-medium truncate">{{ item.label }}</span>
                }
              </div>

              @if (!isCollapsed()) {
              @if (item.expanded) {
              <app-icon-v2 name="ChevronUp" [size]="16" class="text-slate-500 dark:text-slate-400 flex-shrink-0" />
              } @else {
              <app-icon-v2 name="ChevronRight" [size]="16" class="text-slate-500 dark:text-slate-400 flex-shrink-0" />
              }
              }
            </button>

            <!-- Hover Side Card for Collapsed Mode -->
            @if (isCollapsed() && hoveredItem() === item) {
            <div
              class="fixed z-[99999]"
              [style.top.px]="sideCardPosition().top"
              [style.left.px]="sideCardPosition().left"
              (mouseenter)="onSideCardHover()"
              (mouseleave)="onSideCardLeave()"
              [@sideCardSlide]
            >
              <!-- Invisible bridge area -->
              <div class="absolute top-0 -left-3 w-3 h-full"></div>

              <!-- Side card content -->
              <div
                class="bg-white/95 dark:bg-slate-800/95 backdrop-blur-xl border border-purple-200 dark:border-purple-500/30 rounded-lg shadow-xl min-w-48 py-2 overflow-hidden ml-0.5"
                [@sideCardItems]
              >
                <!-- Side card header -->
                <div
                  class="px-4 py-2 border-b border-purple-200/50 dark:border-purple-500/20"
                >
                  <div class="flex items-center gap-2">
                    <app-icon-v2
                      [name]="item.icon"
                      [size]="16"
                      class="flex-shrink-0 text-purple-600 dark:text-purple-400"
                    />
                    <span
                      class="font-medium text-sm text-slate-900 dark:text-slate-100 truncate"
                      >{{ item.label }}</span
                    >
                  </div>
                </div>

                <!-- Side card menu items -->
                <div class="py-1">
                  @for (subItem of item.children; track subItem.id || subItem.label) {
                  @if (!subItem.hidden) {
                  @if (subItem.disabled) {
                  <span
                    class="block w-full px-4 py-2 text-sm text-slate-400 cursor-not-allowed dark:text-slate-500"
                  >
                    {{ subItem.label }}
                  </span>
                  } @else {
                  <button
                    [routerLink]="subItem.route"
                    (click)="setActiveSubItem(item, subItem)"
                    class="w-full cursor-pointer flex items-center gap-2 px-4 py-2 text-sm transition-all duration-150 text-slate-600 hover:bg-purple-50 hover:text-purple-700 dark:text-slate-300 dark:hover:bg-white/5 dark:hover:text-white [&.active]:bg-[#ede9fe] [&.active]:text-violet-900 dark:[&.active]:bg-white/10 dark:[&.active]:text-white"
                    [class.active]="isSubItemActive(subItem)"
                  >
                    <span class="truncate">{{ subItem.label }}</span>
                  </button>
                  }
                  }
                  }
                </div>
              </div>
            </div>
            } } @else {
            <!-- Standalone menu item -->
            <button
              [routerLink]="item.route"
              (click)="setActiveItem(item)"
              class="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 min-w-0 text-slate-600 hover:bg-[#F5F5F5] [&.active]:bg-[#F5F5F5] dark:text-ink-soft [&.active]:dark:bg-surface-3 dark:hover:bg-surface-3 dark:hover:text-white [&.active]:text-[#141437] dark:[&.active]:text-white"
              [class.active]="isParentOrChildActive(item)"
            >
              <app-icon-v2 [name]="item.icon" [size]="20" class="flex-shrink-0" />
              @if (!isCollapsed()) {
              <span class="font-medium truncate">{{ item.label }}</span>
              }
            </button>
            }
          </div>

          <!-- Sub Menu Items -->
          @if (item.children && item.expanded && !isCollapsed()) {
          <div class="ml-4 mt-1 border-l border-slate-200 pl-3 dark:border-slate-600/60" [@submenuAnimation] [@submenuItems]>
            @for (subItem of item.children; track subItem.id || subItem.label) {
            @if (!subItem.hidden) {
            @if (subItem.disabled) {
            <div
              class="mb-1 px-3 py-2 rounded-lg text-sm text-slate-400 cursor-not-allowed dark:text-slate-500"
            >
              {{ subItem.label }}
            </div>
            } @else {
            <button
              [routerLink]="subItem.route"
              (click)="setActiveSubItem(item, subItem)"
              class="w-full cursor-pointer flex items-center gap-2 px-3 py-2 mb-1 rounded-lg text-sm transition-colors duration-200 min-w-0 text-slate-700 hover:bg-violet-50 hover:text-violet-900 dark:text-slate-200 dark:hover:bg-white/5 dark:hover:text-white [&.active]:bg-[#ede9fe] [&.active]:text-violet-900 dark:[&.active]:bg-white/10 dark:[&.active]:text-white"
              [class.active]="isSubItemActive(subItem)"
            >
              <span class="truncate">{{ subItem.label }}</span>
            </button>
            }
            }
            }
          </div>
          }
        </div>
        }
      </nav>
    </div>
  </div>
</aside>
